import { PRODUCTS } from "../../../../lib/constants";

export const slides = [
  {
    product: 'COMMON',
    img: 'user-management-tour-img',
    title: 'User Management',
    description: {
      lines: [
        'User management settings can be found under the profile menu.',
        'Under user management, you can manage roles and active users.',
      ],
      link: 'https://www.youtube.com/watch?v=SYRQVFtzBmM',
    },
  },
  {
    product: PRODUCTS?.EDGE,
    img: 'settlements-tour-img',
    title: 'Merchant Payout Reports (MPR)',
    description: {
      lines: [
        'Inside the settlements tab, click the “Get MPR” option to access and download your MPRs.',
        'Daily MPRs are available to download post 9 p.m.',
      ],
    },
  },
  {
    product: 'COMMON',
    img: 'dropdown-tour-img',
    title: 'Switch Across Products',
    description: {
      lines: [
        'Click the dropdown on the top left corner to seamlessly switch between all your products.',
        '* This option is available only if more than one product is enabled for you.',
      ],
    },
  },
];

export const citi_slides = [
  {
    product: 'COMMON',
    img: 'citi-tour-user-management-gif',
    title: 'User Management',
    description: {
      lines: [
        'User management settings can be found under the profile menu.',
        'Under user management, you can manage roles and active users.',
      ],
      link: 'https://www.youtube.com/watch?v=SYRQVFtzBmM',
    },
  },
  {
    product: PRODUCTS?.EDGE,
    img: 'citi-tour-download-MPR',
    title: 'Merchant Payout Reports (MPR)',
    description: {
      lines: [
        'Inside the settlements tab, click the “Get MPR” option to access and download your MPRs.',
        'Daily MPRs are available to download post 9 p.m.',
      ],
    },
  },
];
export const pacb_slides = [
  {
    product: 'COMMON',
    img: 'pacb-tour-1',
    title: 'Add Payment Details',
    description: {
      lines: [
        'Once a payment is successful, it will show here.',
        'Click on these buttons to add payment details.',
      ],
    },
  },
  {
    product: 'COMMON',
    img: 'pacb-tour-2',
    title: 'Add Payment Details',
    description: {
      lines: [
        'To complete the payment, you need to add these mandatory details.',
        'Note : double check that you’re entering the correct details against correct transaction ID/ Merchant ID.',
      ],
    },
  },
  {
    product: 'COMMON',
    img: 'pacb-tour-3',
    title: 'Add Payment Details',
    description: {
      lines: [
        'Add to submit details & you’re done! Sit back & relax.',
      ],
    },
  },
];
